export const LOCAL_STORAGE_NAME = 'ovgState';
export const BASE_URL = '/api/';
// export const BASE_URL = 'http://localhost:4000/api/';
